import React, { useState } from 'react';
import './Connectivity.css';
import { FaMapMarkerAlt, FaDirections, FaClock, FaExternalLinkAlt, FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';
import logo from '../../assets/images/logo1.png'; 

const Connectivity = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [result, setResult] = useState(""); // Web3Forms status message

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setResult("");
  };

  // Web3Forms Submission Logic
  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    // Using your Access Key
    formData.append("access_key", "68f8c92b-95f6-4539-bca9-456711228405");
    formData.append("subject", "Location Inquiry - Connectivity Section");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Location Details Sent Successfully!");
      event.target.reset();
      setTimeout(() => {
        closeModal();
      }, 2500);
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  const locations = [
    { name: "RTO Pimpri Chinchwad", time: "2 mins" },
    { name: "Spine City Mall", time: "4 mins" },
    { name: "Bhosari District Center", time: "4 mins" },
    { name: "Desai Hospital", time: "7 mins" },
    { name: "D-Mart", time: "10 mins" },
    { name: "City International School", time: "15 mins" },
    { name: "D.Y. Patil College", time: "15 mins" }
  ];

  const containerVariants = {
    hidden: { opacity: 0, x: -100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        staggerChildren: 0.1,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0 }
  };

  return (
    <section id="connectivity" className="connectivity-section">
      <motion.div 
        className="connectivity-container"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }}
      >
        
        <div className="connectivity-header">
          <div className="c-linee"></div>
          <h2 className="c-main-title">Connectivity</h2>
          <div className="c-linee"></div>
        </div>

        <p className="c-desc">
          Sentosa Era at Moshi, Pune offers smooth connectivity to key landmarks. 
          Everything you need is just a few minutes away.
        </p>

        <div className="connectivity-content">
          <motion.div className="map-column" variants={itemVariants}>
            <div className="map-wrapper-mini">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3780.252061094857!2d73.8647!3d18.6632!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c7a5f0b5f5f5%3A0x5f5f5f5f5f5f5f5f!2sSentosa%20Era!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy"
                title="Sentosa Era Moshi Map"
              ></iframe>
              
              <a 
                href="https://maps.google.com" 
                target="_blank" 
                rel="noreferrer" 
                className="view-larger-map"
              >
                <FaExternalLinkAlt /> View Larger Map
              </a>

              <div className="map-tag">
                <div className="live-dot"></div>
                <span>Sentosa Era, Moshi</span>
              </div>
            </div>
          </motion.div>

          <div className="landmarks-column">
            <div className="landmarks-grid-modern">
              {locations.map((loc, index) => (
                <motion.div 
                  key={index} 
                  className="modern-item"
                  variants={itemVariants}
                >
                  <div className="item-left">
                    <div className="icon-circle"><FaMapMarkerAlt /></div>
                    <span className="location-name">{loc.name}</span>
                  </div>
                  <div className="item-right">
                    <FaClock className="clock-icon" />
                    <span className="time-text">{loc.time}</span>
                  </div>
                </motion.div>
              ))}
            </div>
            
            <motion.button 
              className="location-prime-btn"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={openModal}
            >
               <FaDirections /> GET LIVE DIRECTIONS
            </motion.button>
          </div>
        </div>

      </motion.div>

      {/* --- FORM MODAL INTEGRATION (Updated with 5 Fields) --- */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            
            <div className="modal-content">
              <div className="modal-logo">
                <img src={logo} alt="Logo" />
              </div>
              <h2 className="enquire-title">Enquire Now</h2>
              
              <form className="modal-form" onSubmit={onSubmit}>
                <input type="text" name="first_name" placeholder="First Name" required />
                <input type="text" name="last_name" placeholder="Last Name" required />
                <input type="email" name="email" placeholder="Email Id" required />
                <input type="tel" name="mobile" placeholder="Mobile No." required />
                
                {/* <select name="project" required className="modal-select">
                  <option value="" disabled selected>Select Project</option>
                  <option value="Sentosa Era">Sentosa Era</option>
                </select> */}

                <div className="checkbox-container">
                  <input type="checkbox" id="conn-consent" name="consent" required />
                  <label htmlFor="conn-consent">
                    I hereby authorize to send notification on SMS, Calls, RCS, WhatsApp.
                  </label>
                </div>

                <button type="submit" className="modal-submit-btn">
                  SUBMIT NOW <FaArrowRight style={{marginLeft: '8px'}} />
                </button>
              </form>

              {result && <p className="form-status">{result}</p>}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Connectivity;